/**
 * URLs únicas para galería de anuncio: portada + fotos adicionales (orden estable).
 * @param {{ coverUrl?: string|null, cover_url?: string|null, photos?: unknown }} itemOrRow
 * @returns {string[]}
 */
export function listingGalleryUrls(itemOrRow) {
  if (!itemOrRow) return [];
  const seen = new Set();
  const out = [];
  const add = raw => {
    const u = String(raw ?? '').trim();
    if (!u || seen.has(u)) return;
    seen.add(u);
    out.push(u);
  };
  add(itemOrRow.coverUrl ?? itemOrRow.cover_url);
  const photos = itemOrRow.photos;
  if (Array.isArray(photos)) {
    for (const p of photos) add(p);
  }
  return out;
}
